import { createPlatform } from 'map/platform'
import { DiscoverResultItem, SearchService } from 'map/services'
import { Observable } from 'rxjs'

// TODO for future reference those imports should only be part of a WeGo lib
const searchService = createPlatform().getSearchService() as unknown as SearchService

export interface LookupParams {
  id: string
  lang?: string
  show?: string
}

export const lookup = ({ id, lang }: LookupParams): Observable<DiscoverResultItem> =>
  new Observable((observer) => {
    searchService.lookup(
      { id, lang } as LookupParams,
      (item: DiscoverResultItem) => {
        observer.next(item)
        observer.complete()
      },
      (error) => {
        console.error('"/lookup" request error', error)
        observer.error(error)
      }
    )
  })
